export default __webpack_public_path__ + "static/media/Boat2.5df75c06.svg";